// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__pLGJp","requiredAsterisk":"Info_requiredAsterisk__EQP5-"};